import * as React from "react";
import { SliderItem } from "react-compound-slider";

const { Component, Fragment } = React;

// *******************************************************
// HANDLE COMPONENT
// *******************************************************
interface HandleProps {
  key: string;
  handle: SliderItem;
  isActive: Boolean;
  disabled?: Boolean;
  domain: number[];
  getHandleProps: (id: string, config: object) => object;
}

export class Handle extends Component<HandleProps> {
  static defaultProps = {
    disabled: false,
  };

  state = {
    mouseOver: false,
  };

  onMouseEnter = () => {
    this.setState({ mouseOver: true });
  };

  onMouseLeave = () => {
    this.setState({ mouseOver: false });
  };

  render() {
    const {
      domain: [min, max],
      handle: { id, value, percent },
      isActive,
      disabled,
      getHandleProps,
    } = this.props;
    const { mouseOver } = this.state;

    return (
      <Fragment>
        {(mouseOver || isActive) && !disabled ? (
          <div
            style={{
              left: `${percent}%`,
              position: "absolute",
              marginLeft: "-11px",
              marginTop: "-35px",
            }}
          >
          </div>
        ) : null}
        <div
          role="slider"
          aria-valuemin={min}
          aria-valuemax={max}
          aria-valuenow={value}
          style={{
            left: `${percent}%`,
            position: "absolute",
            marginLeft: "-11px",
            marginTop: "-6px",
            zIndex: 400,
            width: 16,
            height: 16,
            cursor: "pointer",
            border: 0,
            borderRadius: "50%",
            boxShadow: "0px 2px 5px 3px rgba(91, 127, 149, 0.4)",
            background: disabled ? "#666" : "linear-gradient(180deg, #5B7F95 0%, #1B365D 100%)",
          }}
          {...getHandleProps(id, {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
          })}
        />
      </Fragment>
    );
  }
}

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface TrackProps {
  source: SliderItem;
  target: SliderItem;
  disabled?: Boolean;
  getTrackProps: () => object;
}

export function Track({
  source,
  target,
  getTrackProps,
  disabled = false,
}: TrackProps) {
  return (
    <div
      style={{
        position: "absolute",
        height: 4,
        zIndex: 1,
        background: disabled ? "#999" : "rgba(91, 127, 149, 0.4)",
        borderRadius: 7,
        cursor: "pointer",
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
}
